/* ============================================================
   NAME THE KILLER — Caso 001 · Villa Aurelia
   Landing funnel behaviour.
   ============================================================ */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  /* ---------- 1. mobile navigation ---------- */
  function initNav() {
    var burger = $('[data-ntk-burger]');
    var nav = $('[data-ntk-mobnav]');
    if (!burger || !nav) return;

    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });

    $$('a', nav).forEach(function (a) {
      a.addEventListener('click', function () {
        burger.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      });
    });
  }

  /* ---------- 2. mini investigation: clue tabs ---------- */
  function initTabs() {
    var tabs = $$('[data-ntk-tab]');
    if (!tabs.length) return;

    function select(name) {
      tabs.forEach(function (t) {
        t.setAttribute('aria-selected', String(t.dataset.ntkTab === name));
      });
      $$('[data-ntk-clue]').forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.ntkClue === name);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { select(t.dataset.ntkTab); });
    });
  }

  /* ---------- 3. mini investigation: answer check ---------- */
  function initQuiz() {
    var quiz = $('[data-ntk-quiz]');
    if (!quiz) return;

    var check = $('[data-ntk-check]', quiz);
    var reveal = $('[data-ntk-reveal]');
    var error = $('[data-ntk-quiz-error]', quiz);
    var correct = quiz.dataset.ntkQuiz;

    $$('input[name="ntk-answer"]', quiz).forEach(function (input) {
      input.addEventListener('change', function () {
        if (error) error.classList.remove('is-visible');
      });
    });

    if (!check) return;
    check.addEventListener('click', function () {
      var chosen = $('input[name="ntk-answer"]:checked', quiz);
      if (!chosen) {
        if (error) error.classList.add('is-visible');
        return;
      }
      if (error) error.classList.remove('is-visible');

      $$('[data-ntk-option]', quiz).forEach(function (label) {
        label.classList.remove('is-right', 'is-wrong');
        if (label.dataset.ntkOption === correct) {
          label.classList.add('is-right');
        } else if (label.dataset.ntkOption === chosen.value) {
          label.classList.add('is-wrong');
        }
      });

      if (reveal) {
        reveal.classList.add('is-open');
        reveal.setAttribute('aria-hidden', 'false');
        var title = $('[data-ntk-reveal-title]', reveal);
        if (title) {
          title.textContent = chosen.value === correct ? 'Exacto.' : 'Casi.';
        }
        window.requestAnimationFrame(function () {
          reveal.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    });
  }

  /* ---------- 4. evidence carousel ---------- */
  function initCarousel() {
    var track = $('[data-ntk-track]');
    if (!track) return;

    var prev = $('[data-ntk-prev]');
    var next = $('[data-ntk-next]');

    function step() {
      var card = $('.ntk-evi__card', track);
      return card ? card.getBoundingClientRect().width + 16 : 280;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- 5. mobile sticky CTA ---------- */
  function initSticky() {
    var bar = $('[data-ntk-sticky]');
    var anchor = $('[data-ntk-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- 6. add to cart, straight to checkout ---------- */
  function initBuy() {
    $$('[data-ntk-buy]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch) return; // let the native POST handle it

        event.preventDefault();
        var button = form.querySelector('button[type="submit"]');
        if (button) button.setAttribute('aria-busy', 'true');

        var data = new FormData(form);
        var item = { id: data.get('id'), quantity: 1 };
        var properties = {};
        Array.prototype.forEach.call(data.entries ? Array.from(data.entries()) : [], function (pair) {
          var match = /^properties\[(.+)\]$/.exec(pair[0]);
          if (match) properties[match[1]] = pair[1];
        });
        if (Object.keys(properties).length) item.properties = properties;

        var json = { 'Content-Type': 'application/json' };

        // Clear first so a second click never buys two copies of a digital case.
        fetch('/cart/clear.js', { method: 'POST', headers: json })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: json,
              body: JSON.stringify({ items: [item] })
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error('cart/add failed');
            window.location.href = '/checkout';
          })
          .catch(function () {
            // Native submit still carries return_to=/checkout.
            form.submit();
          });
      });
    });
  }

  /* ---------- 7. share the challenge ---------- */
  function initShare() {
    var button = $('[data-ntk-share]');
    if (!button) return;

    var label = button.textContent;
    button.addEventListener('click', function () {
      var payload = {
        title: 'NAME THE KILLER · Caso 001',
        text: '¿Puedes descubrir la mentira? Resolvamos este caso juntos.',
        url: window.location.href
      };

      if (navigator.share) {
        navigator.share(payload).catch(function () { /* dismissed */ });
        return;
      }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(payload.url).then(function () {
          button.textContent = 'Enlace copiado';
          window.setTimeout(function () { button.textContent = label; }, 2400);
        });
      }
    });
  }

  /* ---------- 8. reveal on scroll ---------- */
  function initReveal() {
    var items = $$('.ntk-rise');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    items.forEach(function (el) { observer.observe(el); });
  }

  function boot() {
    initNav();
    initTabs();
    initQuiz();
    initCarousel();
    initSticky();
    initBuy();
    initShare();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
